import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListBranding = (params, headers) => request.get('/api/v1/brandings', { params, ...headers });
export const createBranding = data => request.post('/api/v1/brandings', data);
export const updateBranding = data => request.post('/api/v1/brandings/update', data);
export const deleteBranding = data => request.post('/api/v1/brandings/delete', data);
export const changeStatusBranding = data => request.post('/api/v1/brandings/update-status', data);

// Mutation

export const useGetListBrandingMutation = () => useMutation({ mutationFn: getListBranding });
export const useCreateBrandingMutation = () => useMutation({ mutationFn: createBranding });
export const useUpdateBrandingMutation = () =>
  useMutation({
    mutationFn: updateBranding,
  });
export const useDeleteBrandingMutation = () =>
  useMutation({
    mutationFn: deleteBranding,
  });
export const useChangeStatusBrandingMutation = () =>
  useMutation({
    mutationFn: changeStatusBranding,
  });
export const useQueryGetListBranding = (params = {}, options = {}) =>
  useQuery({ queryKey: ['getListBranding', params], queryFn: () => getListBranding(params), ...options });
